module.exports = __webpack_public_path__ + "img/merchant-auth-bg.8cb36c65.svg";